import React, { useContext } from 'react';
import { observer } from 'mobx-react';
import { Box, RadioGroup, Text } from '@wix/design-system';
import { AppContextProvider } from '../../AppLoader';
import { dataHooks } from '../../../dataHooks';

/**
 * The owner-app device picker (radio list of connected devices).
 */
export const DeviceRadioList: React.FC = observer(() => {
  const {
    rootStore: {
      postLoginStore: {
        premiumUsers2FaEnforcementStore: { ownerAppStore: store },
      },
    },
  } = useContext(AppContextProvider);
  return (
    <Box maxHeight={132} overflowY="auto">
      <RadioGroup
        dataHook={dataHooks.ownerAppModal.options}
        value={store.selectedDevice?.id}
        onChange={(id?: string | number) => store.onSelectDevice(id)}
        spacing="12px"
      >
        {store.devices.map(({ id, name }) => (
          <RadioGroup.Radio key={id} value={id}>
            <Text
              weight="thin"
              secondary={store.selectedDevice?.id !== id}
              color="dark"
            >
              {name}
            </Text>
          </RadioGroup.Radio>
        ))}
      </RadioGroup>
    </Box>
  );
});
